import { React, useRef } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BsXCircle } from "react-icons/bs";
import TextField from '@mui/material/TextField';
import Countdown from 'react-countdown';
import { SHOW_MSISDN, SHOW_OTP, SHOW_PACKAGE, SHOW_SUCCESS } from '../../common/constant';
import { customStyles, headerContainerStyle, iconStyle, titleStyle, textStyle } from '../../common/modalStyle'
import MyButton from '../MyButton';
import { isNotNull } from '../../common/utils';
import { useTranslation } from "react-i18next";

const MyRegisterModal = ({ typeModal, dataInit, isOpenOtp, setOpenOtp, confirmClick, errorMessage }) => {
    console.log("typeModal: " + typeModal);

    const dataRef = useRef("");

    const { t } = useTranslation();

    const renderer = ({ minutes, seconds }) => {
        let min = minutes;
        let sec = seconds;
        if (minutes < 10) {
            min = "0" + minutes;
        }
        if (seconds < 10) {
            sec = "0" + seconds;
        }
        return <span>{min}:{sec}</span>;
    }

    function resendOtpClick() {
        console.log("resendOtpClick: ");

    }

    let textField = typeModal == SHOW_MSISDN ?
        <TextField id="standard-basic"
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            inputRef={dataRef}
            label={dataInit == "" ? "Phone number" : ""} variant="standard" style={{ textAlign: "center", width: "70%" }}
            value={dataInit}
            defaultValue={dataInit}
        /> :
        typeModal == SHOW_OTP ?
            <TextField id="standard-basic"
                inputProps={{ min: 0, style: { textAlign: 'center' } }}
                inputRef={dataRef}
                label="OTP" variant="standard" style={{ textAlign: "center", width: "70%" }}
            /> :
            <div></div>

    let timeField = typeModal == SHOW_OTP ?
        <div className='row' style={{ width: "70%", margin: "auto", fontSize: "13px", fontWeight: 600, marginTop: "10px" }}>
            <div className='col-6' style={{ paddingLeft: "0px" }}>
                {t("remain")}: <Countdown date={Date.now() + 60 * 1000} renderer={renderer} />
            </div>
            <div className='col-6' style={{ textAlign: "end", paddingRight: "0px", textDecoration: "underline" }} onClick={resendOtpClick}>
                {t("resendOtp")}
            </div>
        </div> :
        <div></div>

    let desField = typeModal == SHOW_MSISDN ?
        <div>
            <div style={titleStyle}>{t("confirmToSubscriber").toUpperCase()}</div>
            <div style={textStyle}>{t("confirmMsisdn")}</div>
        </div> :
        typeModal == SHOW_OTP ? <div>
            <div style={titleStyle}>{t("confirmToSubscriber").toUpperCase()}</div>
            <div style={isNotNull(errorMessage) && errorMessage != "" ? {
                color: "red",
                textAlign: "center",
                marginTop: "18px"
            } : textStyle}>{isNotNull(errorMessage) && errorMessage != "" ? errorMessage : t("otpSent")}</div>
        </div> :
            <div style={{
                color: "black",
                textAlign: "center",
                marginTop: "20px",
                fontWeight: "600"
            }}>
                Result of transaction
            </div>

    function confirmAction() {
        console.log("dataRef: " + dataRef);
        console.log("dataRef.current: " + dataRef.current);
        // console.log("dataRef.current.value: " + dataRef.current.value);

        if (dataRef === undefined || dataRef === null || dataRef.current === undefined || dataRef.current === null) {
            confirmClick("");
        } else {
            console.log("data: ", dataRef.current.value);
            confirmClick(dataRef.current.value ?? "");
            dataRef.current.value = "";
        }
    }

    return (
        <div>
            <Modal
                isOpen={isOpenOtp}
                onRequestClose={setOpenOtp}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div style={headerContainerStyle}>
                    <div style={iconStyle} onClick={setOpenOtp}>
                        <BsXCircle style={{ height: "2rem", width: "2rem" }} />
                    </div>
                </div>
                {desField}
                {/* <div style={{
                    color: typeModal == SHOW_SUCCESS ? "green" : "red",
                    textAlign: "center",
                    marginTop: "20px"
                }}>
                    
                </div> */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {textField}
                </div>
                {timeField}
                <div style={{ marginTop: "20px" }}>
                </div>
                <MyButton name={t("confirm")} onClickButton={confirmAction} />
                <div style={{ marginTop: "20px" }}>
                </div>
            </Modal>
        </div>
    );
}

export default MyRegisterModal;